import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, ComponentSync, EditableItem, LL_H_C, LL_V_L } from '@nu-art/thunderstorm-frontend/index';
import './Component_ReviewSummary.scss';
import { Component_SmartNote } from '../../physician-notes/Component_SmartNote.js';
import { ICONS } from '@app/styles';
import { ModuleFE_AdvisorMini } from '../../../../modules/ModuleFE_AdvisorMini.js';
import { ModuleFE_AdvisorBoard } from '../../../../_enum.js';
import { ColumnKey_MiddleColumn, ColumnRatio_OneThird, defaultColumnWidthUpdate, MiddleColumn_TwoThirdsRight, PanelKey_Home } from '../../../../_shared.js';
import { ModuleFE_EMInterface } from '@app/advisor-frontend';
import { ModuleFE_Spotlight } from '../../../../modules/ModuleFE_Spotlight/index.js';
import { ModuleFE_AdvisorAnalytics } from '../../../../_analytics/consts.js';
export class Component_ReviewSummary extends ComponentSync {
    //######################### Life Cycle #########################
    deriveStateFromProps(nextProps, state) {
        state.note = new EditableItem(nextProps.note).setSaveAction(async (note) => note);
        state.editMode ??= false;
        return state;
    }
    //######################### Logic #########################
    toggleEditMode = () => {
        const newEditMode = !this.state.editMode;
        this.setState({ editMode: newEditMode });
        if (newEditMode)
            ModuleFE_AdvisorAnalytics.trigger.note.note_edit();
    };
    toggleExpand = () => {
        const currentWidth = ModuleFE_AdvisorBoard.getBoard()[ColumnKey_MiddleColumn].width;
        const nextColumnsWidth = currentWidth === ColumnRatio_OneThird ? MiddleColumn_TwoThirdsRight : defaultColumnWidthUpdate;
        ModuleFE_AdvisorBoard.updateColumnsWidth(nextColumnsWidth);
    };
    sendNote = async () => {
        const smartNote = this.state.note.item;
        try {
            await ModuleFE_EMInterface.vv1.smartNote.writeBack({ note: smartNote }).executeSync();
            if (ModuleFE_AdvisorMini.getIsMiniActive())
                return ModuleFE_AdvisorMini.openPanel(PanelKey_Home);
            ModuleFE_Spotlight.closeSpotlight();
        }
        catch (err) {
            this.logError(err);
        }
    };
    //######################### Render #########################
    render() {
        return _jsxs(LL_V_L, { className: 'review-summary', children: [this.render_Header(), _jsx(Component_SmartNote, { note: this.state.note, editMode: this.state.editMode, asTextBlob: !this.state.editMode }), this.render_Footer()] });
    }
    render_Header = () => {
        return _jsxs(LL_H_C, { className: 'review-summary__header', children: ["Review the summary note and send it to the EHR", _jsxs(LL_H_C, { className: 'review-summary__header-tail', children: [_jsx(ICONS.advisor_v5_freeText.component, { onClick: this.toggleEditMode }), !ModuleFE_AdvisorMini.getIsMiniActive() && _jsx(ICONS.advisor_v5_expand.component, { onClick: () => this.toggleExpand() })] })] });
    };
    render_Footer = () => {
        return _jsx(LL_H_C, { className: 'review-summary__footer', children: _jsx(Button, { variant: 'primary', onClick: this.sendNote, children: "Send to EHR" }) });
    };
}
//# sourceMappingURL=Component_ReviewSummary.js.map